import { EXCHANGES } from '../types/generalTypes';

const dashboard: string = '/dashboard';
const hypertracker: string = '/hypertracker';

export const ROUTES = {
    LOGIN: '/login',
    REGISTRATION: '/signup',
    HOME: `${dashboard}`,
    JOURNAL: `${dashboard}/journal`,
    JOURNAL_ADD: `${dashboard}/journal/add`,
    EXCHANGE: `${dashboard}/exchange`,
    API_MANAGER: `${dashboard}/api-manager`,
    API_MANAGER_ADD: `${dashboard}/api-manager/add`,
    REQUEST_NEW_EXCHANGE: `${dashboard}/api-manager/add/request-new-exchange`,
    STORAGE: `${dashboard}/storage`,
    RESOURCES: `${dashboard}/resources`,
    VERIFICATION: `${dashboard}/verification`,
    VERIFICATION_ADD: `/verification/add`,
    VERIFICATION_EDIT: `/verification/edit`,
    ACCOUNTS: `${dashboard}/accounts`,
    PROFILE_SETTINGS: `${dashboard}/settings`,
    getAccountPage: (exchange: EXCHANGES, accountId: number, search?: string): string =>
        `${dashboard}/accounts/${exchange}/${accountId}${search ? `${search}` : ''}`,
    SSO: '/sso',
    VERIFY_EMAIL: '/verify-email',
    FAILED_AUTH: '/failed-auth',
    EMAIL_TOKEN_VERIFICATION: '/auth/verify',
    RESET_PASSWORD: '/password-reset',
    RESET_PASSWORD_CONFIRM: '/password-reset-url',
    UNLOCKED: `/upgrade/unlocked`,
    UPGRADE: `/upgrade`,
    PURCHASE: `/purchase`,
    PAYPAL_SUCCESS: `/paypal/success`,
    RECEIPT: `/receipt`,
    VALIDATE_TWITTER: `/validate-twitter`,
    CP_SUCCESS: `/coinpayments/success`,
    CP_CANCEL: `/coinpayments/cancel`,
    STRIPE_SUCCESS: `/stripe/success/payment-success`,
    STRIPE_CANCEL: `/stripe/cancel/payment-cancel`,
    NOTIFICATIONS: `${dashboard}/notifications`,
    LEADERBOARD: `${dashboard}/leaderboard`,
    REWARD_HUB: `${dashboard}/reward-hub`,
    INTELLIGENCE: `${dashboard}/intelligence`,
    PERFORMANCE: `${dashboard}/performance`,
    ANALYTICS: `${dashboard}/analytics`,
    CALENDAR: `${dashboard}/calendar`,
    REPORTING: `${dashboard}/reporting`,
    // ================HYPERTRACKER ROUTES===============
    HYPERTRACKER: `${hypertracker}`,
    HYPERTRACKER_SEGMENTS: `${hypertracker}/segments`,
    HYPERTRACKER_WALLET: `${hypertracker}/wallet`,
    HYPERTRACKER_HEATMAP: `${hypertracker}/heatmap`,
    HYPERTRACKER_CONNECTIONS: `${hypertracker}/connections`,
    HYPERTRACKER_FAVORITES: `${hypertracker}/favorites`,
    HYPERTRACKER_PERPS: `${hypertracker}/perps`,
    HYPERTRACKER_BUILDER: `${hypertracker}/builders`,
    HYPERTRACKER_BUILDER_PERSONAL: `${hypertracker}/builder`,
    HYPERTRACKER_STATS: `${hypertracker}/stats`,
    HYPERTRACKER_LEADERBOARDS: `${hypertracker}/leaderboards`,
    HYPERTRACKER_API: `${hypertracker}/api`,
    HYPERTRACKER_ALERTS: `${hypertracker}/alerts`,
    HYPERTRACKER_API_DASHBOARD: `${hypertracker}/api-dashboard`,
    HYPERTRACKER_PRICING: `${hypertracker}/pricing`,
    HYPERTRACKER_MARKET_RADAR: `${hypertracker}/market-radar`,
    HYPERTRACKER_LIQUIDATIONS: `${hypertracker}/liquidations`,
    HYPERTRACKER_FLOWS: `${hypertracker}/flows`,
    HYPERTRACKER_HIP: `${hypertracker}/hip-3`,
    HYPERTRACKER_PURCHASE: `purchase`,
    HYPERTRACKER_OPEN_TESLA: `${hypertracker}/openai-trial`,
    HYPERTRACKER_ALPHAFEED: `${hypertracker}/alphafeed`,
};
